export const initialState = {
  stores: [],
  store: {},
  storeProducts: [],
};
